// extracted by mini-css-extract-plugin
export const container = "Search-module--container--3JJPT";
export const is_open = "Search-module--is_open--3nJmu";